const dtUpdate = require('./retail-dt-update')
const timeDate = require('../../../../../js-handler/time-date')

export const tableDetail = {
      entity: 'retail',
      dest: 'retail',

      tdDataDetail: `data-detail='{ "click": [ {"dest":"ripple" },
                                                {"dest":"retail", "elem":"fullcont", "id":"retail-fullcont", "act":"selectOne", "entity":"retail", "dbid":"#dbid"} ],
                                     "clickRight": [{"dest":"retail", "elem":"dt", "act":"trMenu", "id":"trMenu", "entity":"retail", "dbid":"#dbid" }] }'`,

      filter: {
            mainFilterFields: ['sale.code', 'customer.name', 'purchase.code', 'item.name', 'item.brand'],
            mainFilterValues: ['', ''],
            andFilterFields: [''],
            andFilterValues: [''],
      },
}

export function organizeRow(data) {
      var newData = []

      if (data.length === 0) {
            newData.push({
                  id: 'nothing',
                  colum: [
                        { label: 'No Results', span: '' },
                        { label: '', span: '' },
                        { label: '', span: '' },
                        { label: '', span: '' },
                  ],
            })
            return newData
      }

      data.forEach((elem) => {
            const statusPaymentStyle = dtUpdate.getStatusPaymentStyle(elem)

            newData.push({
                  id: elem.id,
                  colum: [
                        {
                              label: elem.name || 'Generic customer',
                              span: elem.code,
                              style: {
                                    tdClass: 'tdWithAvatar',
                                    avatar: elem.customerAvatar,
                                    avatarColor: elem.customerAvatarColor,
                                    avatarColorLetter: elem.customerAvatarColorLetter,
                                    avatarLetter: elem.customerAvatarLetter,
                              },
                        },
                        { label: elem.qty + ' Units', span: elem.grand_total_dt },
                        { label: timeDate.friendlyDate(elem.sale_date_td), span: timeDate.friendlyTime(elem.date_registered_time) },
                        {
                              label: statusPaymentStyle.label_top,
                              span: statusPaymentStyle.desc,
                              style: {
                                    tdClass: `tdWithIcon ${statusPaymentStyle.icon.color}`,
                                    svg: `./css/svg.svg#${statusPaymentStyle.icon.svg}`,
                              },
                        },
                  ],
            })
      })

      return newData
}

// Genera el historial del fullcont con la misma estructura visual de Sale.
export function organizeRowEntityChange(data) {
      return data.map((elem) => {
            const avatar = elem.avatar || 'css/img/pic/person.svg'
            const parsedChanges = JSON.parse(elem.changes)
            const changesInputs = Array.isArray(parsedChanges.input) ? parsedChanges.input : []
            const changesMt = Array.isArray(parsedChanges.mt) ? parsedChanges.mt : []

            const inputRows = changesInputs.map((input) => {
                  return `<div class="row">
                              <div class="c33">${auditValue(input.elemId)}</div>
                              <div class="c33">${auditValue(input.from)}</div>
                              <div class="c33">${auditValue(input.to)}</div>
                          </div>`
            }).join('')

            const inputSection = inputRows
                  ? `<entry>
                          <div class="row">
                              <div class="c33">Data</div>
                              <div class="c33">From</div>
                              <div class="c33">To</div>
                          </div>
                          ${inputRows}
                      </entry>`
                  : ''

            const multiTableSections = changesMt.map(renderMultiTableChange).join('')
            const userName = String(elem.user_name || '').trim()
            const dateChange = String(elem.date_change || '')

            return `<cont>
                        <user>
                            <photo class="photo" style="background-image: url('${avatar}')"></photo>
                            <title>${auditValue(userName)}</title>
                            <time>${timeDate.friendlyDate(dateChange) + ' | ' + timeDate.friendlyTime(dateChange.substring(10))}</time>
                        </user>
                        ${inputSection}
                        ${multiTableSections}
                    </cont>`
      }).join('')
}

function renderMultiTableChange(table) {
      const fromRows = Array.isArray(table.from) ? table.from : []
      const toRows = Array.isArray(table.to) ? table.to : []
      const headers = ['Status', 'Items', 'Units', 'Qty', 'Unit Price', 'Total']
      let rows = ''

      fromRows.forEach((from, index) => {
            rows += renderMultiTableRow('From', from)
            if (toRows[index]) { rows += renderMultiTableRow('To', toRows[index]) }
      })

      toRows.slice(fromRows.length).forEach((to) => {
            rows += renderMultiTableRow('To', to)
      })

      return `<entry>
                  <div class="row mt-8">
                      <div class="c100">Items</div>
                  </div>
                  <div class="row">
                      ${headers.map((header) => `<div class="c16">${header}</div>`).join('')}
                  </div>
                  ${rows}
              </entry>`
}

function renderMultiTableRow(status, row) {
      const values = [
            row.id,
            row.selling_type,
            row.qty,
            moneyValue(row.price),
            moneyValue(row.total),
      ]

      return `<div class="row">
                  <div class="c16">${status}</div>
                  ${values.map((value) => `<div class="c16">${auditValue(value)}</div>`).join('')}
              </div>`
}

function moneyValue(value) {
      return value === undefined || value === null || value === '' ? '' : `$${value}`
}

function auditValue(value) {
      if (Array.isArray(value)) { return value.map(auditValue).join(', ') }
      if (value && typeof value === 'object') { return auditValue(value.displayText ?? value.id ?? '') }

      return String(value ?? '')
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;')
            .replaceAll("'", '&#039;')
}
